/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import axios from "axios";

axios.defaults.headers.common["Prodtrack-api-version"] = "latest";

export default function () {
    return axios.get("/api/v1/schema/").then(({ data }) => data);
}
